import PropTypes from 'prop-types';
// Utils & misc
import { cn } from '@repo/zolintra-utils';
// Style
import style from './MenuButton.module.css';
// Components
import { Icon, availableIcons } from '../../atoms/Icon/Icon';
import { Tooltip } from '../../atoms/Tooltip/Tooltip';

export function MenuButton({
  onClick, icon, children, className, disabled, isOpen, color,
}) {
  return (
    <Tooltip
      content={children}
      isTriggered={!isOpen}
    >
      <button
        className={cn([
          style.button,
          isOpen && style.open,
          !children && icon ? style.onlyIcon : null,
          color && style[color],
          className,
        ])}
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        {icon ? <Icon icon={icon} className={style.icon} /> : null}
        {isOpen ? <span className={style.label}>{children}</span> : ''}
      </button>
    </Tooltip>
  );
}

MenuButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  icon: PropTypes.oneOf(Object.keys(availableIcons)),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'alert', 'neutral']),
};

MenuButton.defaultProps = {
  children: '',
  onClick: undefined,
  isOpen: true,
  icon: null,
  className: null,
  disabled: false,
  color: 'primary',
};

export default MenuButton;
